export interface FilterComponentChanges extends angular.IOnChangesObject {
    value: angular.IChangesObject<string>;
}

export class FilterComponent implements angular.IOnChanges {
    private value: string = '';
    private onChange?: Function;
    private filterValue: string = '';
    private debounce: number = 100;

    $onInit() {
        this.filterValue = this.value ?? '';
    }

    $onChanges(changes: FilterComponentChanges): void {
        if (changes.value) {
            this.filterValue = changes.value.currentValue;
        }
    }

    change() {
        this.onChange && this.onChange(this.filterValue);
    }

    clear() {
        this.filterValue = '';
        this.change();
    }

    onKeyPress(event: KeyboardEvent) {
        switch (event.key) {
            case 'Esc': // IE/Edge specific value
            case 'Escape':
                this.clear();
                break;
        }
    }
}

angular.module('tradersyard').component('tyFilter', {
    template: `
      <div class="ty_filter">
          <input
                  type="text"
                  ng-model="$ctrl.filterValue"
                  ng-model-options="{debounce: $ctrl.debounce}"
                  ng-change="$ctrl.change()"
                  placeholder="{{$ctrl.placeholder}}"
                  ng-keyup="$ctrl.onKeyPress($event)"
          >
          <div class="ty_filter__input_addon" ng-show="$ctrl.filterValue.length <= 1">
              <i class="fa fa-search"></i>
          </div>
          <div class="ty_filter__input_addon" ng-show="$ctrl.filterValue.length > 1" ng-click="$ctrl.clear()">
              <i class="fa fa-remove"></i>
          </div>
      </div>
    `,
    controller: FilterComponent,
    bindings: {
        value: '<',
        onChange: '<',
        debounce: '<?',
        placeholder: '@',
    },
});
